import type { FaireProductEntity } from "../../entity_types/product";

export const p_2asezecnvg: FaireProductEntity = {
  token: "p_2asezecnvg",
  type: "product",
  name: "Baby's Pom Pom Knitted Hat",
  brandToken: "b_n77n5vays8",
  brandName: "kycozy",
  imageUrl:
    "https://cdn.faire.com/fastly/b4493de941322d79c88da8599dcf1ab547b68f62316d4d4ff699a10b174b9469.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/329b0e696eaec77da34317cfdfb858c9564e825a90149f0992733821a891ffc2.jpeg",
    "https://cdn.faire.com/fastly/b664ef0aa3e471fd2cefce293da4c80259f97ceb6c471349f233401b71a01824.jpeg",
    "https://cdn.faire.com/fastly/128669143c817ce3da8d8f38b1bf66467704a906a6192ec774719977bcc519dd.jpeg",
    "https://cdn.faire.com/fastly/95745f9b6e6c68d971cac4ca82909a1acef347d9dc63d211b35255102f85b1d1.jpeg",
    "https://cdn.faire.com/fastly/1879fc6e26fd0770aef4b3527d20d1bc5909f21482c0281ea5d02157b45547e7.jpeg",
    "https://cdn.faire.com/fastly/81dd2882a0b6c2fd57318b277ef5b5c21295d39cd1840622a173add087dcc47b.jpeg",
    "https://cdn.faire.com/fastly/77dbf713403b9be200848b397b42e27e7e1386d68bda8d97075e2ca5181191f7.jpeg",
    "https://cdn.faire.com/fastly/167501c4c50f80d85a78301decccd08e5aadb03ca10190794e27733cba7db809.jpeg",
    "https://cdn.faire.com/fastly/5e145f6559a10dcccfa8513b2da10dbaaf41b007026f35b19fa4e440a76fa922.jpeg",
    "https://cdn.faire.com/fastly/fa49a803ed232d30f1749a9e35e56573c2e510f2adf28054391f2adac45fe20a.jpeg",
    "https://cdn.faire.com/fastly/fdb8bf082ad32d5b6e2704a0412c7e7efa35be35b1ae401c08cd9ce3d0a99caf.jpeg",
    "https://cdn.faire.com/fastly/cd153450c86c08be041631c7b8419757095683e28cbe3c61eec3ec27cd9dd405.jpeg",
    "https://cdn.faire.com/fastly/f60261d30ce4a9bc4fc37fd2050e002593eee32cc46a5c46e06049b37bd9f60c.jpeg",
    "https://cdn.faire.com/fastly/6cbcfde20eddbe06fb2410f7358fa45ae64244c813312fa00d180b3a765e4df7.jpeg",
    "https://cdn.faire.com/fastly/5212ed18b12655bd33352b36eac1f20a4174a2200be9fd61a7ff09c044e4e4f9.jpeg",
  ],
  priceDollars: 2.49,
  description:
    "Quantity:1 Pcs\n\nSeason : Autumn, Winter \n\nSize : 18*26cm; 58.4g/piece \n\nOccasion : Daily \n\nPattern Type : Plain \n\nColor : Multicolor \n\nStyle : Casual \n\nMaterial : Polyester \n\nDesign : Pom \n\n\n",
  tags: [],
  msrpDollars: 4.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:47:27.573Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
